module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-76x76-7439a05e81b3e8368ede13edf031a65f.png";